import { render } from "./BookCruise.vue?vue&type=template&id=642bf19e&scoped=true"
import script from "./BookCruise.vue?vue&type=script&lang=js"
export * from "./BookCruise.vue?vue&type=script&lang=js"

import "./BookCruise.vue?vue&type=style&index=0&id=642bf19e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642bf19e"]])

export default __exports__